<template src="./template.html"></template>
<style src="./styles.scss" lang="./scss" scoped></style>

<script>
  export default {
    name: 'LinkPreviewItem',
    props: { 'preview': Object },
  }
</script>
